import { useState } from "react";
import Toggle from "@helsenorge/designsystem-react/components/Toggle";
import { useAppDispatch, useAppSelector } from "../../store/reducer";
import { updateOppgavePaminnelse } from "../../store/thunks/thunk-oppgaveDetaljer";

import styles from "../../styles/oppgave-detaljer.module.scss";
import { useGetResources } from "hooks/useGetResources";

export const PaaminnelseToggle = (): React.JSX.Element | null => {
  const dispatch = useAppDispatch();
  const oppgave = useAppSelector((state) => state.oppgaveDetaljer.oppgave);
  const resources = useGetResources();
  const isPaminnelseEnabled = useAppSelector(
    (state) => state.oppgaveDetaljer.isPaminnelseEnabled,
  );

  const [toggleChecked, setToggleChecked] = useState(
    isPaminnelseEnabled ?? false,
  );

  const handleToggle = async () => {
    if (oppgave) {
      dispatch(
        updateOppgavePaminnelse({
          OppgaveGuid: oppgave.Id,
          SkalPaaminnes: !toggleChecked,
        }),
      );
    }
    setToggleChecked(!toggleChecked);
  };

  return (
    <div className={styles.toggle}>
      <Toggle
        checked={toggleChecked}
        label={[
          {
            text: resources?.toggle_paminnelse || "",
            type: "subdued",
          },
        ]}
        onChange={handleToggle}
      />
    </div>
  );
};
